export default {
  common: {
    submit: '送信',
    close: '近い',
    filter: 'フィルター',
    search: '検索',
    reset: 'リセット',
    increase: '増加',
    selectOption: 'オプションを選んでください',
    loading: '読み込み中',
    active: 'アクティブ',
    inactive: '非活性',
    fetchingData: 'データの取得',
    more: 'もっと',
    actions: '行動',
    support: 'サポート',
    dashboard: 'ダッシュボード',
    helpCenter: 'ヘルプセンター',
  },
  sbActionList: {
    emptyActions: '利用可能なアクションはありません。',
  },
  sbCloseButton: {
    escapeAbbreviation: 'ESC',
  },
  sbClipboard: {
    successMessage: 'クリップボードにコピーされました!',
    errorMessage: 'クリップボードにコピーできません。',
  },
  sbDrawer: {
    closePanelAltText: 'パネルを閉じる',
  },
  sbDropdown: {
    noOptions: '利用可能なオプションはありません。',
    noResults: '結果が見つかりません。',
    selectOneOrMore: '1 つ以上の値を選択してください',
  },
  sbFileUpload: {
    chooseFile: 'ファイルを選ぶ...',
  },
  sbFilter: {
    chooseOne: '1 つ選択してください...',
    showAllWhere: 'すべて表示する場所:',
    addFilter: 'フィルターを追加',
    collapseRow: '行を折りたたむ',
    showMore: '+{showMoreQty} もっと見る',
    showLess: '表示を減らす',
    customFilter: 'これはカスタムフィルターです',
    customWrapper: [
      'これはテストとストーリー用のダミー ラッパー コンポーネントです',
      'これは、CollapsableFilter コンポーネントを置き換えます。',
    ],
    filterValue: 'フィルター値:',
  },
  sbTable: {
    expandRow: '行を展開',
    expandAllRows: 'すべての行を展開',
    collapseRow: '行を折りたたむ',
    collapseAllRows: 'すべての行を折りたたむ',
    noRows: '行がありません',
    shipbobTable: 'ShipBob テーブル',
  },
  sbErrorPages: {
    title: 'おっと、これはあなたが探しているボブではありません!',
    sbFourOhFour: {
      subTitle: 'お探しのページを追跡できないようです。',
      helpfulLinks: '代わりに役立つリンクをいくつか紹介します',
    },
    sbFiveHundred: {
      subTitle: '私たち側に問題があるようで、できるだけ早く解決できるよう取り組んでいます。',
      helpText: 'ページをリロードしてみましたか?問題が解決しない場合は、お問い合わせください',
    },
  },
  sbDatePicker: {
    langCode: 'ja',
  },
  sbDraggableFileUpload: {
    dragText: 'ここでファイルをドラッグするか、をクリックします',
    browse: 'ブラウズ ',
    upload: 'アップロードする',
    emptyImageAlt: 'ファイルの空の画像',
    loadedImageAlt: 'ファイルがロードされた画像',
    conjuntion: 'と',
    anyFile: 'どの',
    conditions1: '',
    conditions2: 'ファイルのみが許可され',
    conditions3: '、サイズは',
    conditions4: '以内です。',
  },
};
